<template>
  <canvas :id="id"
          ref="canvas"
          class="pdf-viewer-page box-shadow"
  ></canvas>
</template>

<script>
import { fabric } from "fabric";
let canvasEvents = [
  //Static Canvas events
  // "before:render",
  "after:render",
  // "canvas:cleared",
  "object:added",
  "object:removed",
  //Canvas events
  "object:modified",
  // "object:rotated",
  // "object:scaled",
  // "object:moved",
  // "object:skewed",
  // "object:rotating",
  // "object:scaling",
  // "object:moving",
  // "object:skewing",
  // "before:transform",
  // "before:selection:cleared",
  // "selection:cleared",
  // "selection:updated",
  // "selection:created",
  // "path:created",
  // "mouse:down",
  // "mouse:move",
  // "mouse:up",
  // "mouse:down:before",
  // "mouse:move:before",
  // "mouse:up:before",
  // "mouse:over",
  // "mouse:out",
  // "mouse:dblclick",
  // "dragover",
  // "dragenter",
  // "dragleave",
  // "drop"
];

export default {
  name: 'PDFPage',
  props: {
    id: {
      type: String,
      required: true,
    },
    page: {
      type: Object, // instance of PDFPageProxy returned from pdf-viewer.getPage
      required: true,
    },
    scale: {
      type: Number,
      default: 1.2,
    },
    drawing: {
      type: Boolean,
      default: false
    },
    drawing_color: {
      type: String,
      default: '#f71313'
    },
    drawing_size: {
      type: Number,
      default: 1,
    },

    // optimalScale: {
    //   type: Number,
    //   default: 1.5,
    // },
    // isPageFocused: {
    //   type: Boolean,
    //   default: false,
    // },
    // isElementFocused: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data: () => ({
    el: undefined,
    viewport: undefined,
    context: undefined,
    renderTask: undefined,
    canvas: undefined,

    history: [],
    size: 1,

    options: {
      restrictY: false,
      restrictX: false
    },
    save: {
      name: '',
      saveItems: []
    },

    weights: [ 2, 4, 6 ],

    mouseDown: false,
    mouseX: 0,
    mouseY: 0,
    tempHistory: [],
  }),
  computed: {
    pageNumber() {
      return this.page.pageNumber;
    },
  },
  watch: {
    'page' : function (val, old) {
      this.canvas.dispose()
      this.destroyPage(old);
      this.drawPage()
    },
    'drawing': function (val) {
      this.canvas.isDrawingMode = val
      this.canvas.color = this.drawing_color
      this.canvas.freeDrawingBrush.color = this.drawing_color
      this.canvas.freeDrawingBrush.width = this.drawing_size
    },
    'drawing_color': function (val) {
      this.canvas.color = val
      this.canvas.freeDrawingBrush.color = val
    },
    'drawing_size': function (val) {
      this.canvas.freeDrawingBrush.width = val
    }
  },
  mounted() {
    this.drawPage()
    document.addEventListener('keyup', e => {
      if(e.code === 'Delete' || e.code === 'Backspace' ) {
        this.canvas.remove(this.canvas.getActiveObject())
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('keyup', e => {
      if(e.code === 'Delete' || e.code === 'Backspace' ) {
        this.canvas.remove(this.canvas.getActiveObject())
      }
    })
    canvasEvents.forEach(event => {
      this.canvas.off(event,{page: this.page, canvas: this.canvas});
    });
    // this.canvas.dispose()
    this.destroyPage(this.page);
  },
  methods: {
    drawPage() {
      this.el = this.$refs.canvas
      this.context = this.el.getContext('2d')
      this.viewport = this.page.getViewport({scale: this.scale})
      this.canvas = new fabric.Canvas(this.id, {
        hoverCursor: 'pointer',
        selectionBorderColor: 'green',
        isDrawingMode: false,
        height: this.viewport.height,
        width: this.viewport.width,
      })
      this.canvas.wrapperEl.classList.add('mx-auto')
      this.page.render({canvasContext: this.context, viewport: this.viewport})
          .promise
          .then(() => {

            let img = new Image();
            img.src = this.el.toDataURL();
            img.onload = () => {
              let f_img = new fabric.Image(img);
              this.canvas.setBackgroundImage(
                  f_img,
                  this.canvas.renderAll.bind(this.canvas),
                  {
                    scaleX: this.canvas.width / f_img.width,
                    scaleY: this.canvas.height / f_img.height
                  }
              );
              this.canvas.renderAll();
            };
            // this.canvas.setBackgroundImage(
            //     this.el.toDataURL(),
            //     this.canvas.renderAll.bind(this.canvas),
            //     {
            //       height: this.canvas.height,
            //       width: this.canvas.width
            //     }
            // );
          })
      this.createEvents()
    },
    createEvents() {
      canvasEvents.forEach(event => {
        this.canvas.on(event, () => {
          this.$emit('input', {page: this.page, canvas: this.canvas})
        });
      });
    },
    destroyPage(page) {
      if (page) page._destroy();
      this.destroyRenderTask();
    },
    destroyRenderTask() {
      if (!this.renderTask) return;
      this.renderTask.cancel();
      delete this.renderTask;
    },
  },
}

</script>
